const setting_routes = {
      path: "/setting",
      name: "Setting",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        {
          path: 'person',
          component: () => import('@/views/Setting/PersonSet/PersonSet'),
          meta: {requiresAuth: true},
        },
        {
          path: 'unit',
          component: () => import('@/views/Setting/UnitSet/UnitSet'),
          meta: {requiresAuth: true},
        }
      ]
}

export default setting_routes;
